import * as navigation from 'Navigation';

export default class ProcessTaskFlowchartTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Flowchart',
      closeable: false,
      preferenceKey: 'process-task-flowchart',
    };
  }
}
